/**
 * Haptic Feedback System - Premium tactile feedback
 * Adapted from Karma AC v11
 */

let audioContext: AudioContext | null = null;

export const haptics = {
  // Initialize audio context
  init(): void {
    if (typeof window !== 'undefined' && !audioContext) {
      audioContext = new (window.AudioContext || (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext!)();
    }
  },

  // Play a sound with frequency curve
  playSound(startFreq = 400, endFreq = 600, duration = 0.1, volume = 0.05): void {
    try {
      this.init();
      if (!audioContext) return;
      
      const osc = audioContext.createOscillator();
      const gain = audioContext.createGain();
      
      osc.type = "sine";
      const now = audioContext.currentTime;
      osc.frequency.setValueAtTime(startFreq, now);
      osc.frequency.linearRampToValueAtTime(endFreq, now + duration);
      
      gain.gain.setValueAtTime(volume, now);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
      
      osc.connect(gain);
      gain.connect(audioContext.destination);
      osc.start(now);
      osc.stop(now + duration);
    } catch (err) {
      // Silently fail if audio context unavailable
    }
  },

  // Haptic patterns
  success(): void {
    this.playSound(600, 800, 0.15, 0.08);
  },

  error(): void {
    this.playSound(300, 200, 0.2, 0.1);
  },

  click(): void {
    this.playSound(400, 500, 0.08, 0.04);
  },

  hover(): void {
    this.playSound(500, 600, 0.05, 0.02);
  },

  confirm(): void {
    this.playSound(200, 1000, 0.3, 0.07);
  },

  // Visual feedback - subtle pulse animation
  pulse(element: HTMLElement | null): void {
    if (!element) return;
    element.style.transition = "transform 0.2s ease";
    element.style.transform = "scale(0.95)";
    setTimeout(() => {
      element.style.transform = "scale(1)";
    }, 100);
  },
};

